export default __webpack_public_path__ + "static/media/icon_apacd.b26605bd.webp";